import React from 'react'
import api from './api'
import ReportsList, { defaultReportsList } from '../common/types/api/reportsList'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function getListReports(): Promise<ReportsList> {
    try {
        const res = await api<ReportsList>('list')
        if (!res.success) {
            GlobalNotification.error(
                <Notification title={i18n('Error trying to get the reports list: ')}>{'unknown error'}</Notification>,
                20
            )

            console.error(res)
        }

        return res
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get the reports list: ')}>{error}</Notification>,
            20
        )

        console.error(error)

        return defaultReportsList
    }
}
export function mockGetListReportsReport(data: ReportsList): () => Promise<ReportsList> {
    return function (): Promise<ReportsList> {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(data)
            }, 1000)
        })
    }
}
